/* @flow */

import {
  API_CALL,
  FANTASY_INSIDER_UPDATE_SETTINGS,
  FANTASY_INSIDER_SET_PLAYERS,
  FANTASY_INSIDER_RESET,
  FANTASY_INSIDER_RESET_EXPOSURE_SETTINGS
} from '../constants/actionTypes';

import {
  FANTASY_INSIDER_SAVE_PROJECTION,
  FANTASY_INSIDER_LOAD_PROJECTIONS
} from '../constants/apiTypes';

import * as challengesApi from '../api/challenges';

export function setPlayers(players) {
  return {
    type: FANTASY_INSIDER_SET_PLAYERS,
    players
  };
}

export function updateSettings(settings) {
  return {
    type: FANTASY_INSIDER_UPDATE_SETTINGS,
    settings
  };
}

export function saveProjection(data) {
  return {
    type: API_CALL,
    api: FANTASY_INSIDER_SAVE_PROJECTION,
    request: challengesApi.saveProjection(data)
  };
}

export function loadProjections(slateId) {
  return {
    type: API_CALL,
    api: FANTASY_INSIDER_LOAD_PROJECTIONS,
    request: challengesApi.loadProjections(slateId)
  };
}

export function resetFantasyInsier() {
  return {
    type: FANTASY_INSIDER_RESET
  };
}

export function resetExposureSettings(settings) {
  return {
    type: FANTASY_INSIDER_RESET_EXPOSURE_SETTINGS,
    settings
  };
}
